<template>
  <div class="swiper-container">
    <div class="swiper-wrapper">
      <div class="swiper-slide"><img src="../assets/home/banner1.png" alt="" /></div>
      <div class="swiper-slide"><img src="../assets/home/banner2.png" alt="" /></div>
      <div class="swiper-slide"><img src="../assets/home/banner3.png" alt="" /></div>
      <div class="swiper-slide"><img src="../assets/home/banner4.png" alt="" /></div>
    </div>
    <!-- Add Pagination -->
    <div class="swiper-pagination"></div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
  components: {
    Swiper,
  },
  mounted() {
    new Swiper(".swiper-container", {
      loop: true,
      autoplay: {
        delay: 5000,
        // 用户操作swiper之后，是否禁止autoplay
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
      },
    });
  },
};
</script>
<style scoped>
.swiper-container {
  width: 100%;
  /* height: 300px; */
}
.swiper-wrapper {
  width: 100%;
}
.swiper-wrapper img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue